import { Building } from "lucide-react";
import { Reveal } from "./Reveal";
import { REFERENCES } from "../../data/content";

export const References = () => (
  <section id="referenzen" data-testid="references-section" className="py-20 md:py-28 bg-[#1F2933] overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="text-[#C9B79C] text-xs uppercase tracking-[0.25em] font-semibold mb-4">
          Referenzen
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-3xl">
          Über 20 Jahre Projekterfahrung — privat wie gewerblich
        </h2>
        <p className="mt-4 text-white/70 max-w-2xl text-base md:text-lg">
          Eine Auswahl abgeschlossener Projekte für namhafte Auftraggeber in
          Hamburg und Umgebung.
        </p>
      </Reveal>
    </div>

    <div className="mt-14 relative">
      <div className="flex w-max animate-ticker gap-4 px-2">
        {[...REFERENCES, ...REFERENCES].map((r, i) => (
          <div
            key={i}
            data-testid={i < REFERENCES.length ? `reference-item-${i}` : undefined}
            className="flex items-center gap-3 border border-white/15 bg-white/5 px-6 py-4 whitespace-nowrap transition-colors duration-300 hover:border-[#C9B79C]/60"
          >
            <Building size={16} className="text-[#C9B79C] shrink-0" />
            <span className="text-sm font-semibold text-white/90">{r}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
